/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Section_ContentInputs */



/**
* | output |
* | --- |
* | "Content" |
*
* @param {Community_Section_ContentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_section_content = /** @type {((inputs?: Community_Section_ContentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Section_ContentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contenu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contenido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conteúdo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contenuti")
	return /** @type {LocalizedString} */ ("Content")
});